import React, { useCallback, useEffect, useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { FaWhatsapp } from 'react-icons/fa'
import { getAppSettings } from 'api/app-setting/app-setting'
import { AirconHelp } from './AirconHelp'
import { openModal } from 'service/modal-service'
import { StickyCta, stickyCtaSecondaryClass } from '@/commons/service-hub/StickyCta'

// Aircon version of the shared sticky Book / WhatsApp bar.
// Two things are aircon-specific, both driven by app settings:
//  - waBusinessInd chooses which WhatsApp number to use. The server-rendered
//    link uses the business number from utils/business-info until settings load.
//  - isSelfHelp replaces the WhatsApp link with the AirconHelp chat sheet.
// It is rendered inside the hero (AirconRequestSection), not at the end of the
// page, so it doesn't render the spacer.
//
// selfHelp: false keeps the WhatsApp link even when the country's isSelfHelp
// is on. The AirconHelp prompt (utils/help/aircon-service) answers with
// Singapore prices and /sg links, so UAE / Malaysia pages pass false.
export const BottomButtons = (props) => {
    // onBook: the aircon guides render the card after the article, so "Book"
    // scrolls to it (or opens the matching service page) instead of the top.
    const { countryName, selfHelp = true, onBook = () => scrollTo({ top: 0, behavior: 'smooth' }) } = props
    const [ whatsAppNumber, setWhatsAppNumber ] = useState(null)
    const [ isSelfHelp, setIsSelfHelp ] = useState(false)
    const [ isShowHelp, setIsShowHelp ] = useState(false)

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            if(appSettings.waBusinessInd){
                setWhatsAppNumber("6593512695")
            } else {
                setWhatsAppNumber("6588491419")
            }
            if(appSettings.isSelfHelp && selfHelp){
                setIsSelfHelp(true)
            }
        } catch (error) {
            console.log(error);
        }
    }, [countryName, selfHelp])

    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const selfHelpButton = isSelfHelp &&
        <button type="button" className={stickyCtaSecondaryClass}
            onClick={() => openModal(setIsShowHelp)} aria-label='Chat with Customer Support'>
            <FaWhatsapp className='text-xl' aria-hidden="true"/>
            Chat
        </button>

  return (
    <>
        <StickyCta
            bookLabel="Book"
            onBook={onBook}
            whatsAppHref={whatsAppNumber ? `https://wa.me/${whatsAppNumber}` : undefined}
            secondary={selfHelpButton || null}
            spacer={false}
        />
        {isShowHelp &&
            <AnimatePresence>
                <AirconHelp whatsAppNumber={whatsAppNumber}/>
            </AnimatePresence>
        }
    </>
  )
}
